import {Component, Input, OnInit} from '@angular/core';
import {UserDTO} from '../../services/api/api';
import {UtilService} from 'src/app/services/util.service';

@Component({
  selector: 'sb-avatar',
  templateUrl: './sb-avatar.component.html',
  styleUrls: ['./sb-avatar.component.scss'],
  standalone: false,
})
export class SbAvatarComponent implements OnInit {
  firstFourUser: UserDTO[] | UserDTO[];

  constructor(private util: UtilService) {}

  _users: UserDTO[] | UserDTO[];

  get users(): UserDTO[] | UserDTO[] {
    return this._users;
  }

  @Input('users') set user(val: UserDTO[] | UserDTO[]) {
    this._users = val;
    if (!val) {
      this._users = [];
    } else if (this.users.length > 3) {
      this.firstFourUser = this.users.slice(0, 4);
    }
  }

  ngOnInit(): void {}

  getProfilePic(user: UserDTO) {
    if (user && user.avatar && user.avatar.url) {
      return this.util.appendQueryParamToUrl(user.avatar.url as unknown as string, 'thumbnail=S');
    } else {
      return './assets/img/no-profile-man.png';
    }
  }

  getProfilePicLink(): string {
    if (this.users.length > 0) {
      return ''; // User pic iterator
    }
    return './assets/img/no-profile-man.png';
  }
}
